<div class="msisdn-wrapper">
  <div class="iti-flag" [ngClass]="getFlagClass(msisdn)"></div>
  <div>
    <div class="msisdn-label">{{msisdn.label}}</div>
    <div class="msisdn-value">{{msisdn.msisdn | phoneNumber}}</div>
  </div>
</div>
